module.exports = __webpack_public_path__ + "static/media/es.50623e6a.svg";